/*eslint-disable*/export const messages=JSON.parse("{\"textarea.label.optional\":[\"(valgfrit)\"]}");